import * as Views from "./views";

const Module = {
    name: "fringebenefitcars",
    defaultRoutePath: "/cars/fringebenefitcar",
    menuItemScope: "fleet",
    menuItemName: "fringebenefitcars",

    routes: [
        {
            path: "/cars/fringebenefitcar",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        }
    ],

}

export default Module;
